import { ROUTE_URLS } from 'router/routes'

import { UpgamingSportPages } from 'shared/models/Upgaming'
import AviatorIcon from 'shared/img/slotsPreviewIcons/aviator.png'
import CasinoIcon from 'shared/img/slotsPreviewIcons/casino.png'
import LiveIcon from 'shared/img/slotsPreviewIcons/live.png'
import CasinoLiveIcon from 'shared/img/slotsPreviewIcons/live-casino.png'
import SportIcon from 'shared/img/slotsPreviewIcons/sport.png'
import WheelIcon from 'shared/img/slotsPreviewIcons/wheel.png'
import { localeCommonKeysType } from 'shared/locale/en-US'
import sport from 'components/Header/img/sport.png'

export type ISideMenuSubItem = {
  route: string
  mobileRoute?: string
  textID: localeCommonKeysType
  icon?: string
}

export type ISideMenuItem = {
  route: string
  image?: string
  textID: localeCommonKeysType
  authRequired?: boolean
  subItems?: ISideMenuSubItem[]
}

export const sideMenuItems: ISideMenuItem[] = [
  {
    route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
    textID: 'sport',
    image: SportIcon,
    subItems: [
      { textID: 'digitain', route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'), icon: sport },
      { textID: 'betby', route: ROUTE_URLS.BETBY_SPORT(), icon: sport },
      { textID: 'upgaming', route: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.HOME), icon: sport },
    ],
  },
  {
    route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Overview'),
    textID: 'liveSport',
    image: LiveIcon,
    subItems: [
      {
        textID: 'liveSport1',
        route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Overview'),
        mobileRoute: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Live'),
        icon: sport,
      },
      { textID: 'liveSport2', route: ROUTE_URLS.BETBY_SPORT('live'), icon: sport },
      { textID: 'liveSport3', route: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.LIVE), icon: sport },
    ],
  },
  {
    route: ROUTE_URLS.SLOTS_CASINO(),
    textID: 'casino',
    image: CasinoIcon,
  },
  {
    route: ROUTE_URLS.LIVECASINO(),
    textID: 'liveCasino',
    image: CasinoLiveIcon,
  },
  {
    route: ROUTE_URLS.SLOTS_GAMETYPE('virtual'),
    textID: 'virtualGames',
    image: WheelIcon,
  },
  {
    route: ROUTE_URLS.SLOTS_PROVIDER('otc', 'aviator_spribe'),
    textID: 'aviator',
    image: AviatorIcon,
    authRequired: true,
  },
]
